
import { supabase } from '@/lib/supabase/client';

// Function to fetch profile name by ID
export const fetchProfileName = async (profileId: string): Promise<string> => {
  try {
    const { data: profileData, error: profileError } = await supabase
      .from('social_profiles')
      .select('name')
      .eq('id', profileId)
      .single();
    
    if (profileError) {
      console.error('Error fetching profile:', profileError);
      return "Unknown Channel";
    }
    
    return profileData?.name || "Unknown Channel";
  } catch (error) {
    console.error('Error fetching profile name:', error);
    return "Unknown Channel";
  }
};
